import { translator } from './translator';
import { createSatApi } from '../../../../../lib-sat/api/api.js';
import { conversionOptions } from '../../../../../lib-sat/conversion-options/conversion-options.js';
import { globalLogger } from '../../../../helper/global-logger.js';
import { pageNotification } from '../../../../helper/notify.js';
import { addInputWithRetries } from './add-input-retry';
import { setUpFileExpirationWarning } from '../../helper/file-expiration-warning.js';

var api = null;

function setOutputFilename(job) {
    try {
        var outFilename = job.input[0].filename;
        var filenameNoExtension = outFilename.replace(/(^.+)(\..+)$/, '$1');

        $('#filename').val(filenameNoExtension).prop('placeholder', filenameNoExtension);
    } catch (e) {}
}

function showError(message) {
    if (typeof message !== 'string') {
        message = 'Oops, something went wrong';
    }

    pageNotification.error(message);
}

function showGenericErrorBox() {
    globalLogger.error('image editor - show error generic');

    $('#errorGeneric, .btn-return').removeClass('hidden');
}

function showJobErrorBox(jobId) {
    var jobIdParts = jobId.split('-');

    globalLogger.error('image editor - show error jobid');

    $('#errorJobId').removeClass('hidden').find('#ticketId').html(jobIdParts[0]);

    $('.btn-return').removeClass('hidden');
}

function show410Error() {
    window.allowLeave = true;

    globalLogger.error('image editor - show error 410');

    $('.editor-error-wrapper').removeClass('hidden');
    $('.wait-animation>.ui-loader').addClass('hidden');

    $('#error410, .btn-return').removeClass('hidden');
}

function showFinalInputError() {
    hideLoadingAnimation();

    $('#errorFinalInput').removeClass('hidden');
}

function showLoadingErrorBox(jobId) {
    window.allowLeave = true;

    if (typeof jobId === 'string') {
        showJobErrorBox(jobId);
    } else {
        showGenericErrorBox();
    }

    $('.editor-error-wrapper').removeClass('hidden');
    $('.wait-animation>.ui-loader').addClass('hidden');
}

function toDataURL(src, callback, outputFormat) {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.naturalHeight;
        canvas.width = this.naturalWidth;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);

        callback(dataURL, canvas.height, canvas.width);

        img = null;
        ctx = null;
        canvas = null;
    };

    img.onerror = function () {
        show410Error();
        img = null;
    };

    img.src = src;
    if (img.complete || img.complete === undefined) {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
        img.src = src;
    }
}

function initPixie(job, config) {
    config = $.extend(true, {}, config);

    api = createSatApi({});

    var navItems = [
        {
            name: 'Fullscreen',
            icon: 'copy-custom',
            action: function () {
                var supportsFullScreen = false;
                var prefix = '';
                var browserPrefixes = 'webkit moz o ms khtml'.split(' ');

                // check for native support
                if (typeof document.cancelFullScreen !== 'undefined') {
                    supportsFullScreen = true;
                } else {
                    // check for fullscreen support by vendor prefix
                    for (var i = 0, il = browserPrefixes.length; i < il; i++) {
                        prefix = browserPrefixes[i];

                        if (typeof document[prefix + 'CancelFullScreen'] !== 'undefined') {
                            supportsFullScreen = true;
                            break;
                        }
                    }
                }

                if ((screen.availHeight || screen.height - 30) <= window.innerHeight) {
                    if (prefix === '') {
                        return document.cancelFullScreen();
                    }

                    return document[prefix + 'CancelFullScreen']();
                }

                if (supportsFullScreen) {
                    var element = $('.main-content').get(0);
                    if (prefix === '') {
                        return element.requestFullScreen();
                    }

                    return element[prefix + 'RequestFullScreen']();
                }
            },
        },
    ];

    var pixConfig = {
        image: null,
        baseUrl: '/assets/vendor/pixie',
        crossOrigin: true,
        ui: {
            mode: 'inline',
            compact: true,
            height: '100%',
            allowEditorClose: true,
            openImageDialog: {
                show: false,
            },
            toolbar: {
                hide: true,
            },
            nav: {
                replaceDefault: false,
                items: [],
            },
        },
        tools: {
            draw: {
                replaceDefaultBrushTypes: true,
                brushTypes: [
                    // removed brushes because they were broken
                    // TODO fix the broken brushes in the vendor
                    'PencilBrush',
                    // 'VLineBrush',
                    // 'DiamondBrush',
                    // 'HLineBrush',
                    'CircleBrush',
                    // 'SquareBrush',
                    'SprayBrush',
                ],
            },
            crop: {
                replaceDefaultPresets: true,
                presets: [
                    { ratio: '1:1', name: '1:1' },
                    { ratio: '3:2', name: '3:2' },
                    { ratio: '5:3', name: '5:3' },
                    { ratio: '4:3', name: '4:3' },
                    { ratio: '5:4', name: '5:4' },
                    { ratio: '6:4', name: '6:4' },
                    { ratio: '7:5', name: '7:5' },
                    { ratio: '10:8', name: '10:8' },
                    { ratio: '16:9', name: '16:9' },
                ],
            },
        },
    };

    var _translations = translator.getTranslations();

    if (window.operation === 'crop') {
        // for some reason the crop editor completely breaks if the translations object contains the 'crop' key
        // TODO: figure out why this breaks
        delete _translations.crop;
    }

    pixConfig.languages = {
        active: 'current',
        custom: {
            current: _translations,
        },
    };

    if (typeof config === 'object') {
        var hasItems = false;

        try {
            hasItems = config.ui.nav.hasOwnProperty('items');
        } catch (e) {}

        if (hasItems) {
            $.each(config.ui.nav.items, function (idx, val) {
                pixConfig.ui.nav.items.push(val);
            });

            delete config.ui.nav.items;
        }

        $.each(navItems, function (idx, val) {
            pixConfig.ui.nav.items.push(val);
        });

        pixConfig = $.extend(true, pixConfig, config);
    }

    toDataURL(job.output[0].uri, function (dataUrl, height, width) {
        pixConfig.image = dataUrl;

        var maxHeightOrWidth = Math.max(height, width);
        if (maxHeightOrWidth > 4096) {
            pixConfig.textureSize = maxHeightOrWidth;
        }

        pixie = new Pixie(pixConfig);

        setTimeout(function () {
            if (window.doingFinalJob === true || window.addingFile === true) {
                return;
            }

            var isCanvasVisible = $('.canvas-wrapper').is(':visible');
            var isToolbarVisible = $('editor-controls .tool-panel-container, editor-controls navigation-bar').is(
                ':visible'
            );
            if (!isCanvasVisible || !isToolbarVisible) {
                globalLogger.log(
                    'image editor - editor not loaded after 20 seconds',
                    'isCanvasVisible: ' + isCanvasVisible + '; isToolbarVisible: ' + isToolbarVisible
                );
            }
        }, 20000);

        setTimeout(function () {
            if (window.doingFinalJob === true || window.addingFile === true) {
                return;
            }

            var isCanvasVisible = $('.canvas-wrapper').is(':visible');
            var isToolbarVisible = $('editor-controls .tool-panel-container, editor-controls navigation-bar').is(
                ':visible'
            );
            if (!isCanvasVisible || !isToolbarVisible) {
                globalLogger.log(
                    'image editor - editor not loaded after 60 seconds',
                    'isCanvasVisible: ' + isCanvasVisible + '; isToolbarVisible: ' + isToolbarVisible
                );
            }
        }, 60000);

        initClickEvents();
    });

    setUpFileExpirationWarning();
}

function initClickEvents() {
    $(document).on('click', '.btn-zoom-in', function () {
        if (!pixie.canvas.zoom.canZoomIn()) {
            return;
        }

        pixie.canvas.zoom.zoomIn();
    });

    $(document).on('click', '.btn-zoom-out', function () {
        if (!pixie.canvas.zoom.canZoomOut()) {
            return;
        }

        pixie.canvas.zoom.zoomOut();
    });

    $(document).on('click', '.settings-toggle', function () {
        $(this).find('i').toggleClass('fa-caret-up fa-caret-down');
        $('.pixie-settings-panel').find('.form-group, .panel-heading').toggleClass('hidden');
        $('image-editor .canvas-wrapper').toggleClass('w-100');

        $('.pixie-settings-panel-container').toggleClass('settings-hidden');
        $('.submit-editor-container').removeClass('hidden');
    });

    $(document).on('click', '#submitBtn, #submitBtnBottom', function () {
        $(this).prop('disabled', true);

        pixSubmit();
    });

    /**
     * NOTE: for this to work, I added the functions
     * canUndo() and canRedo() to history-tool.service.ts in the pixie vendor,
     * since it was removed for no reason whatsoever yet is still in the documentation
     */
    $(document).on('click', '.pixie-undo', function () {
        var pixHistory = pixie.getTool('history');

        if (pixHistory.canUndo()) {
            $('.pixie-redo').removeClass('disabled');
            pixHistory.undo();
        }

        // I implemented it like this because, if the previous action is undone,
        // I need to check if there is no more action to undo so I can disable the button
        if (!pixHistory.canUndo()) {
            $(this).addClass('disabled');
        }
    });

    /**
     * NOTE: for this to work, I added the functions
     * canUndo() and canRedo() to history-tool.service.ts in the pixie vendor,
     * since it was removed for no reason whatsoever yet is still in the documentation
     */
    $(document).on('click', '.pixie-redo', function () {
        var pixHistory = pixie.getTool('history');

        if (pixHistory.canRedo()) {
            $('.pixie-undo').removeClass('disabled');
            pixHistory.redo();
        }

        // I implemented it like this because, if the previous action is redone,
        // I need to check if there is no more action to redo so I can disable the button
        if (!pixHistory.canRedo()) {
            $(this).addClass('disabled');
        }
    });

    /**
     * NOTE: for this to work, I added the functions
     * canUndo() and canRedo() to history-tool.service.ts in the pixie vendor,
     * since it was removed for no reason whatsoever yet is still in the documentation
     */
    $(document).on('click', 'image-editor', function () {
        var pixHistory = pixie.getTool('history');

        if (pixHistory.canRedo()) {
            $('.pixie-redo').removeClass('disabled');
        }

        if (pixHistory.canUndo()) {
            $('.pixie-undo').removeClass('disabled');
        }
    });

    $(document).on('click', 'button.menu-toggle', function () {
        var target = '.menu-toggle-show, .menu-toggle-hide, .' + $(this).data('target');
        var classes = 'hidden-xs hidden-sm hidden-md hidden-lg hidden-xl';

        $(target).toggle().removeClass(classes);
    });

    $(document).on('click', '[data-hide-error]', function () {
        var selector = $(this).attr('data-hide-error');
        var $element = $(selector);

        if ($element.length > 0) {
            $element.addClass('hidden');
        }
    });
}

function startConversion(pixOut) {
    window.doingFinalJob = true;
    var host = window.location.hostname;
    host = host.replace(/(.+\.)(\w+)(\..{3,4})/, '$2');

    var conversion = conversionOptions.getConversionOptionsFromForm('#sendform');

    var postJob = {
        operation: window.operation,
        previousJob: window.originalJob.id,
    };

    var outputFilename = $('#filename').val();

    if (outputFilename === '') {
        outputFilename = 'output';
    }

    function jobCreateSuccess(jobInfo) {
        var finalJob = jobInfo;
        var token = jobInfo.token;

        api.addConversion(finalJob.id, conversion)
            .done(function () {
                var postData = {
                    url:
                        finalJob.server.replace(/(.+)(online-convert)(.com)(\/.+)/, '$1' + host + '$3$4') +
                        '/upload-base64/' +
                        finalJob.id,
                    data: JSON.stringify({
                        content: pixOut,
                        filename: outputFilename,
                    }),
                    dataType: 'json',
                    headers: {
                        'x-oc-token': token,
                    },
                };

                addInputWithRetries(finalJob.id, postData)
                    .done(function () {
                        window.allowLeave = true;

                        var resultUrl = '/result#j=' + finalJob.id;

                        if (sat.locale !== 'en') {
                            resultUrl = '/' + sat.locale + '/result#j=' + finalJob.id;
                        }

                        window.location = resultUrl;
                    })
                    .fail(function () {
                        globalLogger.error('image editor - final job add input fail');

                        $('#submitBtn').prop('disabled', false);
                        api = null;

                        api = createSatApi({});
                        showFinalInputError();
                    });
            })
            .fail(function () {
                globalLogger.error('image editor - final job add conversion fail');
                showLoadingErrorBox(finalJob.id);
            });
    }

    api.createJob(postJob)
        .done(function (jobInfo) {
            jobCreateSuccess(jobInfo);
        })
        .fail(function () {
            globalLogger.error('image editor - final job create fail');
            showLoadingErrorBox();
        });
}

function showLoadingAnimation() {
    $('.wait-animation').removeClass('hidden');

    $('.ui-loader').removeClass('hidden');
    $('.ui-loading').addClass('hidden');

    $('.pixie-container').addClass('hidden');
}

function hideLoadingAnimation() {
    $('.wait-animation').addClass('hidden');

    $('.ui-loader').addClass('hidden');
    $('.ui-loading').removeClass('hidden');

    $('.pixie-container').removeClass('hidden');
}

function pixSubmit() {
    var pixOut = '';

    if (!conversionOptions.isConversionOptionsFormValid('#sendform')) {
        $('#submitBtn').prop('disabled', false);
        return;
    } else {
        showLoadingAnimation();
    }

    if (!window.hasOwnProperty('pixApplied') || window.pixApplied === false) {
        pixie.applyChanges();

        setTimeout(function () {
            pixOut = pixie.getTool('export').getDataUrl();
            startConversion(pixOut);
        }, 500);
    } else {
        pixOut = pixie.getTool('export').getDataUrl();
        startConversion(pixOut);
    }
}

export { initPixie };
export { setOutputFilename };
export { pixSubmit };
export { showLoadingAnimation };
export { hideLoadingAnimation };
export { showError };
export { showLoadingErrorBox };
export { toDataURL };
